var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKuehneNagel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1536 1528",
    width: 1536,
    height: 1528,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "KNIN") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #003369 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Clip-Path: Page 1",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Page 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 3",
    fillRule: "evenodd",
    className: "s0",
    d: "m0 760.5c0-419.6 344.4-760 768-760 423.1 0 767.5 340.4 767.5 760 0 189.5-68.7 363.9-185.5 499.3l-99.2-100.8c91.7-111.8 142.3-252.6 142.3-398.5 0-343.9-283.2-628.7-625.1-628.7-342.4 0-625.6 284.8-625.6 628.7 0 145.9 50.6 286.7 142.3 398.5l-98.7 100.8c-117.3-135.4-186-309.8-186-499.3zm371.5 486.8q136.8 129.3 327.8 149.3v-536.9h-131.3v-99.2h131.3v-80.7c-63.1-23.6-106.3-79.2-106.3-153.4 0-97.3 77.2-173 175-173 97.3 0 174.5 75.7 174.5 173 0 74.2-43.2 129.8-106.3 153.4v80.7h131.8v99.2h-131.8v536.9c127.8-12.5 236.1-63.1 327.8-149.3l93.8 100.7c-131.4 116.8-307.8 180-489.8 180-182 0-358.9-63.2-490.3-180zm470.2-722.4c0-41.8-33.8-75.7-75.6-75.7-41.9 0-75.7 33.9-75.7 75.7 0 41.9 33.8 75.7 75.7 75.7 41.8 0 75.6-33.8 75.6-75.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuehneNagel);
export default __webpack_public_path__ + "static/media/kuehne_nagel.288a246c541405e7fc5e033250f289f4.svg";
export { ForwardRef as ReactComponent };